<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <b-tabs v-else class="animated fadeIn">
    <b-tab
      v-for="(task, index) in process_tasks"
      :key="index"
      :title="task.name"
      @click="changeTab"
      lazy
    >
      <!-- <b-row class="pr-3">
        <b-col
          v-for="(instance, instrument_index) in getTaskInstances(task)"
          :key="instrument_index"
          cols="3"
          class="mb-3 pr-0"
          @click="pickInstance(instance.id)"
        >
          <b-card
            no-body
            :class="`${
              picked_instance_id === instance.id ? 'picked' : ''
            } px-1 py-2 mb-0 pointer`"
          >
            <div>{{ instance.identifier }}</div>
            <div>{{ instance.instrument.name }}</div>
            <instrument-capacity-bar
              class="d-inline-block w-100"
              :instrument_instance="instance"
              :process="schedule_process"
            />
          </b-card>
        </b-col>
      </b-row> -->
      <schedule-detail-sample-table
        :sample_list="current_sample_list"
        :schedule_process="schedule_process"
        :instrument_jig_collection="instrument_jig_collection"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import InstrumentCapacityBar from "@/components/lab/instrument/InstrumentCapacityBar";
import ScheduleDetailSampleTable from "./ScheduleDetailSampleTable";
import {
  getTabData,
  getInitialInstanceData,
  getTaskInstances,
} from "@/shared/utils";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "ScheduleDetailProcessTab",
  components: { InstrumentCapacityBar, ScheduleDetailSampleTable },
  props: {
    schedule: {
      type: Object,
      default: () => null,
    },
    schedule_process: {
      type: Object,
      default: () => null,
    },
    sample_collection: {
      type: Object,
      default: () => null,
    },
    instrument_jig_collection: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        sample_set: "on_instrument",
      },
      picked_instance_id: null,
      picked_task_id: null,
      instrument_instance_schedules: [],
    };
  },
  computed: {
    process_tasks() {
      return this.schedule_process.schedulable_process.schedulable_tasks.filter(
        ({ id }) =>
          this.schedule_process.process_schedule_instrument_instances.find(
            ({ process_task_id }) => id === process_task_id
          )
      );
    },
    current_sample_list() {
      let data = this.instrument_instance_schedules.reduce((acc, cur) => {
        if (
          cur.schedulable_task_id === this.picked_task_id &&
          cur.instrument_instance_id === this.picked_instance_id
        ) {
          return [...acc, cur];
        }

        return acc;
      }, []);

      return data;
    },
    process_jig_id_list() {
      return this.instrument_instance_schedules.reduce(
        (acc, { instrument_jig_id }) => {
          const check = acc.find((jig_id) => jig_id === instrument_jig_id);

          check && (acc = [...acc, instrument_jig_id]);

          return acc;
        },
        []
      );
    },
  },
  methods: {
    async init() {
      this.initialInstancePick();
      await this.fetchInstrumentInstanceSchedules();
    },
    async fetchInstrumentInstanceSchedules() {
      let collection = await getCollection({
        collection_type: "instrument_instance_schedule",
        connections: [
          "sample",
          "sample.submission",
          "sample.submission.project",
          "sample.submission.project.customer",
          "sample.submission.turnaround",
        ],
        filters: [
          {
            logic: "filterEquals",
            field: "process_schedule_id",
            value: this.schedule_process.id,
          },
        ],
        sort: [
          {
            logic: "sortAddAsc",
            field: "schedule_index",
          },
        ],
        limit: "all",
        message: this.$bvToast,
      });
      this.instrument_instance_schedules = collection.models;
    },
    initialInstancePick() {
      const { instrument_instance_id, process_task_id } =
        getInitialInstanceData(this.schedule_process) || {};
      this.picked_instance_id = instrument_instance_id;
      this.picked_task_id = process_task_id;
    },
    getTaskInstances(task) {
      return getTaskInstances(this.schedule_process, task);
    },
    pickInstance(instance_id) {
      this.picked_instance_id = instance_id;
    },
    changeTab() {
      const { instrument_instance_id, process_task_id } = getTabData(
        this.schedule_process,
        this.$children,
        0
      );
      this.picked_instance_id = instrument_instance_id;
      this.picked_task_id = process_task_id;
    },
  },
  created() {
    this.loading = true;
    this.init().then(() => {
      this.loading = false;
    });
  },
};
</script>

<style>
.picked {
  background-color: #20a8d8;
  color: white;
}
</style>
